import { BrowserModule } from '@angular/platform-browser';
import { Module as StripeModule } from "stripe-angular"
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HighlightJsModule } from 'ngx-highlight-js';
import {HttpClientModule} from '@angular/common/http';

//Ruteo de la web
import { routing, appRoutingProviders } from './app.routing';
import { DefaultService } from '../services/default.service';
import { MyGuard } from '../services/my-guard.service';

//Firebase y firestore
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';

//Components
import { AppComponent } from './app.component';
import { PaymentComponent } from './payment/payment.component';
import { HomeComponent } from './home/home.component';
import { Error1Component } from './Errores/error1/error1.component';
import { Error2Component } from './Errores/error2/error2.component';
import { Error3Component } from './Errores/error3/error3.component';
import { Error4Component } from './Errores/error4/error4.component';
import { CygwinNotepadComponent } from './Instalaciones/cygwin-notepad/cygwin-notepad.component';
import { BashProfileComponent } from './Utilidades/bash-profile/bash-profile.component';
import { InstallComponent } from './Instalaciones/install/install.component';
import { FirestoreComponent } from './Instalaciones/firestore/firestore.component';
import { JqueryComponent } from './Instalaciones/jquery/jquery.component';
import { BuildComponent } from './Instalaciones/build/build.component';
import { GoogleCloudPlatformComponent } from './Utilidades/google-cloud-platform/google-cloud-platform.component';
import { InstallPluginsComponent } from './Consejos/install-plugins/install-plugins.component';
import { ComandosComponent } from './Consejos/comandos/comandos.component';
import { IonloadLeaveComponent } from './Consejos/ionload-leave/ionload-leave.component';
import { ConsultasComponent } from './Consejos/consultas/consultas.component';
import { ContadoresComponent } from './Consejos/contadores/contadores.component';
import { CrearServicioComponent } from './Consejos/crear-servicio/crear-servicio.component';
import { JsonLineasComponent } from './Utilidades/json-lineas/json-lineas.component';
import { FormulariosComponent } from './Utilidades/formularios/formularios.component';
import { TimerComponent } from './Utilidades/timer/timer.component';
import { ParametrosComponent } from './Utilidades/parametros/parametros.component';
import { StorageIonicComponent } from './Utilidades/storage-ionic/storage-ionic.component';
import { TraduccionesComponent } from './Utilidades/traducciones/traducciones.component';
import { IonSelectComponent } from './Utilidades/ion-select/ion-select.component';
import { FotoUrlComponent } from './Utilidades/foto-url/foto-url.component';
import { BorrarColeccionesComponent } from './Utilidades/borrar-colecciones/borrar-colecciones.component';
import { FechasComponent } from './Utilidades/fechas/fechas.component';
import { AnimacionesComponent } from './design/animaciones/animaciones.component';
import { FontsComponent } from './Design/fonts/fonts.component';
import { FotoFondoComponent } from './Design/foto-fondo/foto-fondo.component';
import { ImagenScrollComponent } from './Design/imagen-scroll/imagen-scroll.component';
import { ImagenPorDefectoComponent } from './Design/imagen-por-defecto/imagen-por-defecto.component';
import { ComoLlegarComponent } from './Design/como-llegar/como-llegar.component';
import { DivAbsoluteComponent } from './Design/div-absolute/div-absolute.component';
import { NotificacionesComponent } from './Practicos/notificaciones/notificaciones.component';
import { ComentariosDestacadosComponent } from './Practicos/comentarios-destacados/comentarios-destacados.component';
import { SubirFotosComponent } from './Practicos/subir-fotos/subir-fotos.component';
import { SubirAudiosComponent } from './Practicos/subir-audios/subir-audios.component';
import { ReproductorComponent } from './Practicos/reproductor/reproductor.component';
import { MapsComponent } from './Practicos/maps/maps.component';
import { LoginRegisComponent } from './Practicos/login-regis/login-regis.component';
import { RecPassComponent } from './Practicos/rec-pass/rec-pass.component';
import { AdmobComponent } from './Plugins/admob/admob.component';
import { StripeComponent } from './Plugins/stripe/stripe.component';
import { ProyectoComponent } from './Practicos/proyecto/proyecto.component';
import { RegistroComponent } from './registro/registro.component';
import { ProyectoDComponent } from './design/proyecto-d/proyecto-d.component';
import { IdiomasComponent } from './idiomas/idiomas.component';

import { HttpClient } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Http, HttpModule, } from '@angular/http';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}


const firebase = {
  apiKey: "AIzaSyBHcwvyMjEtDRJHe1a4BzaVguw_0TmECr8",
  authDomain: "ienrique-b3f8e.firebaseapp.com",
  databaseURL: "https://ienrique-b3f8e.firebaseio.com",
  projectId: "ienrique-b3f8e",
  storageBucket: "ienrique-b3f8e.appspot.com",
  messagingSenderId: "221749994531"
};

@NgModule({
  declarations: [
    AppComponent,
    PaymentComponent,
    HomeComponent,
    Error1Component,
    Error2Component,
    Error3Component,
    Error4Component,
    CygwinNotepadComponent,
    BashProfileComponent,
    InstallComponent,
    FirestoreComponent,
    JqueryComponent,
    BuildComponent,
    GoogleCloudPlatformComponent,
    InstallPluginsComponent,
    ComandosComponent,
    IonloadLeaveComponent,
    ConsultasComponent,
    ContadoresComponent,
    CrearServicioComponent,
    JsonLineasComponent,
    FormulariosComponent,
    TimerComponent,
    ParametrosComponent,
    StorageIonicComponent,
    TraduccionesComponent,
    IonSelectComponent,
    FotoUrlComponent,
    BorrarColeccionesComponent,
    FechasComponent,
    AnimacionesComponent,
    FontsComponent,
    FotoFondoComponent,
    ImagenScrollComponent,
    ImagenPorDefectoComponent,
    ComoLlegarComponent,
    DivAbsoluteComponent,
    NotificacionesComponent,
    ComentariosDestacadosComponent,
    SubirFotosComponent,
    SubirAudiosComponent,
    ReproductorComponent,
    MapsComponent,
    LoginRegisComponent,
    RecPassComponent,
    AdmobComponent,
    StripeComponent,
    ProyectoComponent,
    RegistroComponent,
    ProyectoDComponent,
    IdiomasComponent
  ],
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    HighlightJsModule,
    routing,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(firebase), 
    AngularFirestoreModule,
    StripeModule,
    BrowserModule
  ],
  providers: [
    MyGuard,
    DefaultService,
    appRoutingProviders
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts